<div class="recommendations-wrapper">
  <h2 class="section-title">Articles You May Like</h2>
  @for (item of items; track trackBySlug($index, item)) {
    <div class="col-sm-4">
      <div class="recommendation-item">
        <div style="display: flex;">
          <ut-avatar-badges [user]="item.user" uiSref="profile.about" [uiParams]="{profileId: item.user.slug}"></ut-avatar-badges>
          <div class="feed-item-info">
            <a class="feed-item-info__title"
              uiSref="profile.about"
              [uiParams]="{profileId: item.user.slug}"
            [attr.aria-label]="'Article Author, ' + item.user.name">{{item.user.name}}</a>
            <ut-dynamic-tooltip [user]="item.user" tooltipType="user">
              <span tabindex="0"
                class="fa fa-info-circle"
                role="button"
              [attr.aria-label]="'Open ' + item.user.name + ' tooltip'"></span>
            </ut-dynamic-tooltip>
            <small>
              Article • <span>{{item.published_at | relativeDate}}</span>
            </small>
          </div>
        </div>
        <div class="recommendation-item-title">
          <a (click)="track(item)"
            uiSref="singlearticle"
            [uiParams]="{articleId: item.slug}"
            [uiSrefOpts]="{inherit: false}"
          [innerHTML]="item.title | emojiHtml"></a>
        </div>
        <div class="recommendation-item-footer">
          <a (click)="track(item)"
            uiSref="singlearticle"
            [uiParams]="{articleId: item.slug}"
          [uiSrefOpts]="{inherit: false}">Read More</a>
        </div>
      </div>
    </div>
  }
</div>
